import React, { useState } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import { useUser } from "../../Context/UserContext"; 

import DepartmentTarget from "./DepartmentTarget";
import DistrictTarget from "./DistrictTarget";
import BlockTarget from "./BlockTarget";
import NurseryTarget from "./NurseryTarget";

const Target = () => {
  const { role } = useUser();
  
  const getInitialTab = () => {
    if (role === "block_admin") return "block";
    if (role === "district_admin") return "district";
    return "department";
  };

  const [tab, setTab] = useState(getInitialTab());

  return (
    <Box sx={{ width: "100%", typography: "body1", backgroundColor: "#e8f7e0", minHeight: '100vh' ,}}>
      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
        <Tabs
          value={tab}
          onChange={(e, val) => setTab(val)}
          sx={{
            '& .Mui-selected': { color: '#1b5e20 !important', fontSize: '1.2rem' },
            '& .MuiTabs-indicator': { backgroundColor: '#1b5e20' },
            '& .MuiTab-root': {
              fontSize: '1.1rem',
              fontWeight: 'bold',
              textTransform: 'none',
              minWidth: 150
            }
          }}
        >
          {role !== "district_admin" && role !== "block_admin" && (
            <Tab label="Department" value="department" />
          )}
          
          {role !== "block_admin" && (
            <Tab label="District" value="district" />
          )}

          <Tab label="Block" value="block" />
          <Tab label="Nursery" value="nursery" />
        </Tabs>
      </Box>

      <Box>
        {tab === "department" && role !== "district_admin" && role !== "block_admin" && <DepartmentTarget />} 
        {tab === "district" && role !== "block_admin" && <DistrictTarget />}
        {tab === "block" && <BlockTarget role={role} />}
        {tab === "nursery" && <NurseryTarget />}
      </Box>
    </Box>
  );
};

export default Target;